module.exports = __webpack_public_path__ + "img/s4.7d27f6bb.png";